import { memo } from 'react';

import FilterRecurrentActionStatus from '@/src/modules/CampaignsModule/components/RecurrentActions/TableContainer/components/ActionsFilterBar/components/FilterRecurrentActionStatus';

const FiltersActionDropdown = () => {
  return <FilterRecurrentActionStatus />;
};

export default memo(FiltersActionDropdown);
